import Arrow from "./Arrow";
import Arrow2 from "./Arrow2";
import Arrow3 from "./Arrow3";
import ArrowClient from "./ArrowClient";

import AddUser from "./AddUser";
import AdForm from "./AdForm";
import Audience from "./Audience";
import TheTradeDesk from "./TheTradeDesk";
import Client from "./Client";
import CheckCircle from "./CheckCircle";
import ClientActivations from "./ClientActivations";
import ClientUpload from "./ClientUpload";
import ClientDownload from "./ClientDownload";
import Cog from "./Cog";
import Map from "./Map";
import Edit from "./Edit";
import Close from "./Close";
import Close2 from "./Close2";
import Dots from "./Dots";
import Document from "./Document";
import Download from "./Download";
import Expanded from "./Expanded";
import Eye from "./Eye";
import FacebookPlatform from "./FacebookPlatform";
import Gear from "./Gear";
import Google360 from "./Google360";
import GoogleAds from "./GoogleAds";
import Snapchat from "./Snapchat";
import GuideIcon1 from "./GuideIcon1";
import GuideIcon2 from "./GuideIcon2";
import GuideIcon3 from "./GuideIcon3";
import GuideIcon4 from "./GuideIcon4";
import HeaderSearch from "./HeaderSearch";
import HeaderNotify from "./HeaderNotify";
import HeaderHelp from "./HeaderHelp";
import LoginUser from "./LoginUser";
import LogOut from "./LogOutIcon";
import Lock from "./Lock";
import Lock2 from "./Lock2";
import PaymentCard from "./PaymentCard";
import Plus from "./Plus";
import QuestionCircle from "./QuestionCircle";
import InfoCircle from "./InfoCircle";
import Report from "./Report";
import Stacked from "./Stacked";
import Share from "./Share";
import Tick from "./Tick";
import Tick2 from "./Tick2";
import Trash from "./Trash";
import MagniFyingGlass from "./MagniFyingGlass";
import Fail from "./Fail";
import Xandr from "./Xandr.png";
import SmartClip from "./SmartClip.png";
import Settings from "./Settings";
import HeaderSearchNew from "./HeaderSearch_new";
import SuccessSvg from "./SuccessSvg";
import PostalCodes from "./PostalCodes";
import LlCoords from "./LlCoords";

export { default as LogoIcon } from "./LogoIcon";
export default {
  LlCoords,
  AdForm,
  Arrow,
  Arrow2,
  Arrow3,
  ArrowClient,
  Audience,
  TheTradeDesk,
  Client,
  ClientActivations,
  ClientUpload,
  ClientDownload,
  CheckCircle,
  Document,
  Download,
  FacebookPlatform,
  Gear,
  Map,
  Google360,
  GoogleAds,
  Snapchat,
  GuideIcon1,
  GuideIcon2,
  GuideIcon3,
  GuideIcon4,
  LogOut,
  QuestionCircle,
  InfoCircle,
  Report,
  AddUser,
  LoginUser,
  Eye,
  Edit,
  Plus,
  Dots,
  Close,
  Close2,
  Stacked,
  Share,
  Expanded,
  MagniFyingGlass,
  HeaderSearch,
  HeaderSearchNew,
  HeaderNotify,
  HeaderHelp,
  Cog,
  PaymentCard,
  Tick,
  Tick2,
  Trash,
  Lock,
  Lock2,
  Fail,
  Xandr,
  SmartClip,
  Settings,
  SuccessSvg,
  PostalCodes
};
